// extracted by mini-css-extract-plugin
export var addButton = "_iq-0";
export var border = "_iq-8";
export var check = "_iq-h";
export var danger = "_iq-6";
export var dropdownContainer = "_iq-1";
export var editModalBody = "_iq-j";
export var footerContainer = "_iq-i";
export var fullWidth = "_iq-a";
export var hide = "_iq-9";
export var icon = "_iq-3";
export var input = "_iq-7";
export var inputFlex = "_iq-b";
export var inputWrapper = "_iq-c";
export var manualFocus = "_iq-5";
export var optionButton = "_iq-4";
export var pillWrapper = "_iq-e";
export var pointer = "_iq-2";
export var showOverflow = "_iq-f";
export var tagsFlex = "_iq-d";
export var xButton = "_iq-g";